import { useMemo } from 'react'

import MapCountry from './MapCountry'
import Icon from '../../../../components/UI/Icon'
import LightOrangeTooltip from '../../../../components/UI/LightOrangeTooltip'

import { addZeroBeforeNumber } from '../../../../helpers'

import { colors, tutorMapColors } from '../../../../constants'
import calculateOtherCountriesPercentage from '../../../../helpers/calculateOtherCountriesPercentage'

const MapCountries = ({ studentsByCountry, countries }) => {
  const countriesLength = studentsByCountry.length
  const mainCountries = studentsByCountry.slice(0, 5)
  const restCountries = studentsByCountry.slice(5)

  const restCountriesStudents = useMemo(() => {
    return restCountries
      .map((country) => country.students.length)
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
  }, [restCountries])

  const students = useMemo(() => {
    return studentsByCountry
      .map((country) => country.students.length)
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
  }, [studentsByCountry])

  const mapCountriesContent = mainCountries.map((country, index) => {
    return (
      <MapCountry
        key={country.id}
        country={country}
        countryInfo={countries.find((c) => c.iso_3166_1_a3 === country.id)}
        colorTheme={colors[tutorMapColors[index]]}
      />
    )
  })

  return (
    <div className="flex items-start w-full p-[24px] rounded-[8px] border-[#FFC9AB] border-[1px] mt-[16px]">
      <div className="flex flex-col items-start mr-[100px]">
        <div className="flex items-center mb-[24px]">
          <span className="text-[#F67443] text-2xl font-bold font-Inter">
            {addZeroBeforeNumber(students)}
          </span>

          <span className="text-sm font-normal font-Inter text-[#F67443] ml-[8px]">
            Students From
          </span>
        </div>

        <div className="flex items-center">
          <span className="text-[#F67443] text-2xl font-bold font-Inter">
            {addZeroBeforeNumber(countriesLength)}
          </span>

          <span className="text-sm font-normal font-Inter text-[#F67443] ml-[8px]">Countries</span>
        </div>
      </div>

      <div className="flex-1 flex items-start flex-wrap gap-[8px]">
        {mapCountriesContent}

        {!!restCountries.length && (
          <MapCountry
            country={{
              students: restCountriesStudents,
              percentage: calculateOtherCountriesPercentage(mainCountries, restCountries),
              color: 'brown',
            }}
            countryInfo={{
              printable_name: 'Other Countries',
            }}
            colorTheme={colors.brown}
            nameSuffix={
              <LightOrangeTooltip
                title={
                  <div className="flex items-tart flex-wrap w-full gap-x-[2px] gap-y-[16px]">
                    {restCountries.map((country) => {
                      return (
                        <span key={country.id} className="w-[49%] font-semibold">
                          {countries.find((c) => c.iso_3166_1_a3 === country.id)?.printable_name ||
                            country.id}{' '}
                          <span className="font-normal">
                            - {country.students.length} Student
                            {country.students.length > 1 ? 's' : ''}
                          </span>
                        </span>
                      )
                    })}
                  </div>
                }
                placement="top"
              >
                <div>
                  <Icon name="info-outline" className="ml-[4px] w-[16px] h-[16px]" />
                </div>
              </LightOrangeTooltip>
            }
          />
        )}
      </div>
    </div>
  )
}

export default MapCountries
